import { createAsyncThunk } from '@reduxjs/toolkit'
import postValidatePin from '../../api/postValidatePin'
import mapPinValidationResponseToFormState from '../mapping/mapPinValidationResponseToFormState'

export const validatePin = createAsyncThunk(
  'pin/validate',
  async ({ pin, lastName }) => {
    return await postValidatePin(pin, lastName)
  }
)
export const validatePinReducer = {
  [validatePin.fulfilled]: (state, action) => {
    if (!action.payload.errorMessage) {
      mapPinValidationResponseToFormState(state, action.payload)
    }
  },
  [validatePin.rejected]: (state, action) => {
    throw Error(action.error.message)
  }
}